import {Inject, Injectable, Optional, SkipSelf} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IndicatifEntity} from "./indicatif.entity";

@Injectable({ providedIn: 'root' })
export class IndicatifService {
    private path: string;

    constructor( //
        @Inject(HttpClient) private httpClient: HttpClient, //
        @Optional() @SkipSelf() previousInstance?: IndicatifService
    ){
        if (previousInstance) {
            throw new Error(
                'IndicatifService is already loaded. Import it in the AppModule only');
        }
        this.path = (window as any).baseApiPath;
    }

    public getAllIndicatif() : Observable<IndicatifEntity[]> {
        let url = this.path + "indicatif"
        let result = this.httpClient.get<IndicatifEntity[]>(url);
        return result;
    }
}